import { GetServerSideProps } from 'next'
import { LoginPage } from '@mc/persona-client'
import { getPersonaAuthServerProps } from '../utils/getPersonaAuthServerProps'

const Login = ({ errorMessage }: { errorMessage?: string }) => (
  <LoginPage errorMessage={errorMessage} />
)

Login.pageSettings = {
  hideNavigation: true,
  title: 'MasterClass On Call',
  footer: { hide: true },
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const personaProps = await getPersonaAuthServerProps(ctx, true)
  const { query } = ctx
  if (personaProps?.redirect) {
    return personaProps
  }

  return {
    props: {
      ...(query.error && { errorMessage: query.error }),
    },
  }
}

export default Login
